/**
 *
 * @module playbackMetrics
 *
 */

/**
 *
 * @class PlaybackMetrics
 * @desc Contains a snapshot of information about media playback.
 * @since 2.0.0
 *
 */
export default class PlaybackMetrics {

    /**
     *
     * @param {Number} currentBitrate
     * @param {Number} currentPlayhead
     *
     */
    constructor(currentBitrate, currentPlayhead) {

        /**
         *
         * @access public
         * @type {Number}
         * @desc Gets or sets the current bitrate in Kbps.
         *
         */
        this.currentBitrate = currentBitrate;

        /**
         *
         * @access public
         * @type {Number}
         * @desc Gets or sets the current playhead position.
         *
         */
        this.currentPlayhead = currentPlayhead;

    }

}



// WEBPACK FOOTER //
// ./src/media/playbackMetrics.js